
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexGeVhB6vw0gMeta } from "/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue?macro=true";
import { default as indexZ4PhJriHF6Meta } from "/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue?macro=true";
import { default as login4GZDhJo7VLMeta } from "/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue?macro=true";
import { default as indexH0g0IkTwvHMeta } from "/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue?macro=true";
import { default as managerwz0yfoiT7eMeta } from "/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue?macro=true";
import { default as health8rUNjVFWLZMeta } from "/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue?macro=true";
import { default as _91id_93DPctBUP0GzMeta } from "/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue?macro=true";
import { default as indexarMGrdgaF9Meta } from "/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue?macro=true";
import { default as indexHRqmSVOuZeMeta } from "/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue?macro=true";
import { default as indexdiztBma4soMeta } from "/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue?macro=true";
export default [
  {
    name: "booking___en-US",
    path: "/en-US/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___en___default",
    path: "/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___en",
    path: "/en/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___fr-FR",
    path: "/fr-FR/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___fr",
    path: "/fr/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___de-DE",
    path: "/de-DE/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___de",
    path: "/de/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___es-ES",
    path: "/es-ES/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___es",
    path: "/es/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___it-IT",
    path: "/it-IT/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___it",
    path: "/it/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___nl-NL",
    path: "/nl-NL/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___nl",
    path: "/nl/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___pt-PT",
    path: "/pt-PT/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking___pt",
    path: "/pt/booking",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/index.vue")
  },
  {
    name: "booking-manager___en-US",
    path: "/en-US/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___en___default",
    path: "/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___en",
    path: "/en/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___fr-FR",
    path: "/fr-FR/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___fr",
    path: "/fr/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___de-DE",
    path: "/de-DE/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___de",
    path: "/de/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___es-ES",
    path: "/es-ES/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___es",
    path: "/es/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___it-IT",
    path: "/it-IT/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___it",
    path: "/it/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___nl-NL",
    path: "/nl-NL/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___nl",
    path: "/nl/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___pt-PT",
    path: "/pt-PT/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager___pt",
    path: "/pt/booking/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/index.vue")
  },
  {
    name: "booking-manager-login___en-US",
    path: "/en-US/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___en___default",
    path: "/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___en",
    path: "/en/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___fr-FR",
    path: "/fr-FR/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___fr",
    path: "/fr/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___de-DE",
    path: "/de-DE/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___de",
    path: "/de/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___es-ES",
    path: "/es-ES/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___es",
    path: "/es/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___it-IT",
    path: "/it-IT/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___it",
    path: "/it/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___nl-NL",
    path: "/nl-NL/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___nl",
    path: "/nl/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___pt-PT",
    path: "/pt-PT/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "booking-manager-login___pt",
    path: "/pt/booking/manager/login",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/booking/manager/login.vue")
  },
  {
    name: "bookings___en-US",
    path: "/en-US/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___en___default",
    path: "/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___en",
    path: "/en/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___fr-FR",
    path: "/fr-FR/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___fr",
    path: "/fr/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___de-DE",
    path: "/de-DE/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___de",
    path: "/de/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___es-ES",
    path: "/es-ES/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___es",
    path: "/es/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___it-IT",
    path: "/it-IT/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___it",
    path: "/it/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___nl-NL",
    path: "/nl-NL/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___nl",
    path: "/nl/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___pt-PT",
    path: "/pt-PT/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings___pt",
    path: "/pt/bookings",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/index.vue")
  },
  {
    name: "bookings-manager___en-US",
    path: "/en-US/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___en___default",
    path: "/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___en",
    path: "/en/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___fr-FR",
    path: "/fr-FR/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___fr",
    path: "/fr/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___de-DE",
    path: "/de-DE/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___de",
    path: "/de/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___es-ES",
    path: "/es-ES/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___es",
    path: "/es/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___it-IT",
    path: "/it-IT/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___it",
    path: "/it/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___nl-NL",
    path: "/nl-NL/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___nl",
    path: "/nl/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___pt-PT",
    path: "/pt-PT/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "bookings-manager___pt",
    path: "/pt/bookings/manager",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/bookings/manager.vue")
  },
  {
    name: "health___en-US",
    path: "/en-US/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___en___default",
    path: "/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___en",
    path: "/en/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___fr-FR",
    path: "/fr-FR/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___fr",
    path: "/fr/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___de-DE",
    path: "/de-DE/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___de",
    path: "/de/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___es-ES",
    path: "/es-ES/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___es",
    path: "/es/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___it-IT",
    path: "/it-IT/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___it",
    path: "/it/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___nl-NL",
    path: "/nl-NL/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___nl",
    path: "/nl/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___pt-PT",
    path: "/pt-PT/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "health___pt",
    path: "/pt/health",
    meta: health8rUNjVFWLZMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/health.vue")
  },
  {
    name: "hotels-id___en-US",
    path: "/en-US/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___en___default",
    path: "/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___en",
    path: "/en/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___fr-FR",
    path: "/fr-FR/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___fr",
    path: "/fr/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___de-DE",
    path: "/de-DE/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___de",
    path: "/de/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___es-ES",
    path: "/es-ES/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___es",
    path: "/es/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___it-IT",
    path: "/it-IT/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___it",
    path: "/it/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___nl-NL",
    path: "/nl-NL/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___nl",
    path: "/nl/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___pt-PT",
    path: "/pt-PT/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels-id___pt",
    path: "/pt/hotels/:id()",
    meta: _91id_93DPctBUP0GzMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/[id].vue")
  },
  {
    name: "hotels___en-US",
    path: "/en-US/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___en___default",
    path: "/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___en",
    path: "/en/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___fr-FR",
    path: "/fr-FR/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___fr",
    path: "/fr/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___de-DE",
    path: "/de-DE/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___de",
    path: "/de/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___es-ES",
    path: "/es-ES/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___es",
    path: "/es/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___it-IT",
    path: "/it-IT/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___it",
    path: "/it/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___nl-NL",
    path: "/nl-NL/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___nl",
    path: "/nl/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___pt-PT",
    path: "/pt-PT/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "hotels___pt",
    path: "/pt/hotels",
    meta: indexarMGrdgaF9Meta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/hotels/index.vue")
  },
  {
    name: "index___en-US",
    path: "/en-US",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___fr-FR",
    path: "/fr-FR",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___de-DE",
    path: "/de-DE",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___es-ES",
    path: "/es-ES",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___it-IT",
    path: "/it-IT",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___nl-NL",
    path: "/nl-NL",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___pt-PT",
    path: "/pt-PT",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexHRqmSVOuZeMeta || {},
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/index.vue")
  },
  {
    name: "payment___en-US",
    path: "/en-US/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___en___default",
    path: "/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___en",
    path: "/en/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___fr-FR",
    path: "/fr-FR/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___fr",
    path: "/fr/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___de-DE",
    path: "/de-DE/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___de",
    path: "/de/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___es-ES",
    path: "/es-ES/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___es",
    path: "/es/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___it-IT",
    path: "/it-IT/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___it",
    path: "/it/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___nl-NL",
    path: "/nl-NL/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___nl",
    path: "/nl/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___pt-PT",
    path: "/pt-PT/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  },
  {
    name: "payment___pt",
    path: "/pt/payment",
    component: () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/pages/payment/index.vue")
  }
]